/**
 * 配套RN-Bridge的JSBridge
 */
// import mockData from '../interface/mockData'; // 注入mock数据
export const initJSBridge = (mock = false) => {
  if (window.JSBridge) return window.JSBridge;
  let callbackIdCalculator = 0;
  const callbacks = {};
  const registerFuncs = {};
  let nativeBridge = window;
  if (mock) {
    // nativeBridge = {
    //   postMessage: (obj) => {
    //     obj = typeof obj === 'string' ? JSON.parse(obj) : obj;
    //     const { functionName, data, callbackId } = obj;
    //     if (!functionName) {
    //       // const { responseId, data } = obj;
    //       setTimeout(() => {
    //         window.JSBridge.receiveMessage({
    //           data,
    //           callbackId
    //         });
    //       }, 1000);
    //     } else {
    //       // 调用native注入方法
    //       const response = mockData[functionName]; // 模拟native注册的程序
    //       window.JSBridge.receiveMessage({ callbackId, data: { ...data, ...response } });
    //     }
    //   }
    // };
  }
  window.JSBridge = {
    // js调用native接口, 如果只是注册，并不调用,data不用传或传null，返回一个id
    // 当想执行时 callback设为返回的id，并附上需要的参数
    invoke(functionName, callback, data = null) {
      console.log(functionName);
      let thisCallbackId;
      if (typeof callback === 'function') {
        thisCallbackId = ++callbackIdCalculator;
        callbacks[thisCallbackId] = callback;
        if (data === null) {
          return thisCallbackId;
        }
      } else {
        thisCallbackId = callback;
      }

      console.log({
        functionName,
        data: data || {},
        callbackId: thisCallbackId,
      });
      if (this._getSystem() !== -1) {
        nativeBridge.postMessage(
          JSON.stringify({
            functionName,
            data: data || {},
            callbackId: thisCallbackId,
          }),
          '*',
        );
      } else {
        throw Error('未知移动设备！');
      }
      return undefined;
    },
    // native调用js
    receiveMessage(params) {
      console.log(params);
      const { functionName, callbackId, responseId, errorCode, errorMsg } = params;
      const data = params.data || {};

      if (errorCode) {
        // eslint-disable-next-line no-console
        console.log(errorCode, errorMsg);
      }

      if (callbackId && callbacks[callbackId]) {
        callbacks[callbackId](data);
      } else if (functionName) {
        const result = {};
        if (registerFuncs[functionName]) {
          Object.assign(result, registerFuncs[functionName](data));
        } else {
          result.error = '未找到调用方法';
        }
        nativeBridge.postMessage(
          JSON.stringify({
            responseId,
            data: result,
          }),
        );
      }
      return undefined;
    },
    // 提供给native调用的方法，此方法有待扩充
    register: (functionName, callback) => {
      // Fixed 允许重新注册方法
      registerFuncs[functionName] = callback;
    },
    // 判断是安卓还是ios 0:android  1:ios -1:错误
    _getSystem: () => {
      const ua = navigator.userAgent;
      if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) {
        return 0;
      }
      if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        return 1;
      }
      return -1;
    },
    // 判断安卓版本
    _getAndroidVersion: () => {
      const ua = navigator.userAgent.toLowerCase();
      let version = null;
      if (ua.indexOf('android') >= 0) {
        const reg = /android [\d._]+/gi;
        const vInfo = ua.match(reg);
        // 得到版本号
        version = `${vInfo}`.replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.');
        // 得到版本号第1,2位
        version = parseFloat(`${version.split('.')[0]}.${version.split('.')[1]}`);
      }

      return version;
    },
    // 判断ios版本
    _getIosVersion: () => {
      const ua = navigator.userAgent.toLowerCase();
      let version = null;
      if (ua.indexOf('like mac os x') >= 0) {
        const reg = /os [\d._]+/gi;
        const vInfo = ua.match(reg);
        // 得到版本号9.3.2或者9.0
        version = `${vInfo}`.replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.');
        // 得到版本号第1,2位
        version = parseFloat(`${version.split('.')[0]}.${version.split('.')[1]}`);
      }

      return version;
    },
  };
  window.document.addEventListener('message', textValue => {
    window.JSBridge.receiveMessage(JSON.parse(textValue.data));
  });
  return undefined;
};
